// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  FileCategory,
} from "./types";

export default {
  requestId: __t.u128(),
  versionId: __t.u64(),
  relativePath: __t.string(),
  get category() {
    return FileCategory;
  },
  sizeBytes: __t.u64(),
  hash: __t.string(),
  chunkSizeBytes: __t.u32(),
};
